import { environmentHttpClient as httpClient } from "../httpClient";

export type PixabayUserModel = {
	id: number;
	name: string;
};

export type PixabayImageModel = {
	id: number;
	cdnPreviewUrl: string;
	previewUrl: string;
	downloadId: string;
	author: PixabayUserModel | null;
};

export function searchPixabay(
	searchTerm: string | null,
	skip: number,
	take: number,
	signal?: AbortSignal
): Promise<LazyLoadPageResult<PixabayImageModel>> {
	return httpClient.get<LazyLoadPageResult<PixabayImageModel>>(
		"UiApi/ImageGallery/Pixabay",
		{
			searchTerm,
			skip,
			take
		},
		{ signal }
	);
}

export function download(
	downloadId: string,
	signal?: AbortSignal
): Promise<Blob> {
	return httpClient.getBlob(
		"UiApi/ImageGallery/Pixabay/Download",
		{ downloadId },
		{ signal }
	);
}